// Хүүхэд (бага анги) — v0.1 "Хүүхэд": толгой (хүүхэд, анги, улирал), энэ 7 хоногийн төсөл, оролцооны үйл явц (MIAP),
// ажиглалт, хэлсэн үг, агшин, сурлага хөгжлийн үйл явц (хичээл бүр), ирц; "Сургууль" (хоол, чөлөө, өдөр өнжүүлэх, санал хүсэлт,
// календарь) — цэснээс энд шилжсэн, /school?c= хуудас руу.
import React from "react";
import { Link } from "react-router-dom";
import { Spin } from "antd";
import { FiCalendar, FiClock, FiMessageSquare, FiCoffee, FiChevronRight, FiCheck } from "react-icons/fi";
import ElemChild from "../Home/ElemChild";
import Subjects from "./Subjects";
import { Avatar, KidTabs, ProjectCard, md, useOverview } from "./shared";

export default function ElemChildPage({ child, kids, onPick }) {
  const ov = useOverview(child.id);
  return (
    <div className="flex flex-col gap-3.5 md:gap-5">
      <KidTabs kids={kids} value={child.id} onChange={onPick} />
      <header className="flex flex-wrap items-center gap-3 md:gap-4 pt-1">
        <Avatar s={ov?.student || child} size={52} />
        <div className="flex-1 min-w-0">
          <h1 className="m-0 text-2xl md:text-[28px] font-extrabold leading-tight">{child.firstName}</h1>
          <div className="text-sm text-[#6e5e8a]">{[`${child.grade}-р анги`, ov?.term ? `${ov.term.name}, ${md(ov.term.startDate)} – ${md(ov.term.endDate)}` : null].filter(Boolean).join(" · ")}</div>
        </div>
      </header>
      {ov === null ? <div className="flex justify-center py-6"><Spin /></div> : ov && <ProjectCard child={child} project={ov.project} today={ov.today} />}
      {/* Даалгавар — багшийн төсөлд оруулсан (lms_task), хүүхэд хийсэн бол ✓ */}
      {ov?.tasks?.length > 0 && (
        <section aria-labelledby="task-h" className="tj-card px-4 pt-[18px] pb-2 md:p-6">
          <div className="text-xs font-extrabold tracking-[0.12em] uppercase text-[#6e5e8a]">Даалгавар</div>
          <h2 id="task-h" className="m-0 text-xl md:text-[22px] font-bold">{child.firstName}-ийн даалгавар</h2>
          <div className="mt-2">{ov.tasks.map((t) => (
            <div key={t.id} className="flex items-start gap-3 py-3.5 border-t border-[#efedf4]">
              <span className={`mt-0.5 h-6 w-6 rounded-full border-2 shrink-0 flex items-center justify-center ${t.done ? "bg-primary border-primary text-white" : "border-primary"}`}>{t.done && <FiCheck size={14} />}</span>
              <span className="flex-1 min-w-0">
                <span className={`block text-[15px] md:text-base font-semibold ${t.done ? "text-[#6e5e8a]" : ""}`}>{t.name}</span>
                {t.description && <span className="block text-sm text-[#6e5e8a] whitespace-pre-line">{t.description}</span>}
                {t.dueDate && <span className="inline-flex items-center gap-1 text-[13px] text-[#6e5e8a] mt-0.5"><FiClock size={13} />{md(t.dueDate)} хүртэл{t.done ? " · хийсэн" : ""}</span>}
              </span>
              {t.label && <span className="hidden sm:inline-flex items-center h-7 px-3 rounded-full bg-[#e0f7fa] text-[#0e7490] text-[13px] font-semibold whitespace-nowrap">{t.label}</span>}
            </div>
          ))}</div>
        </section>
      )}
      <ElemChild child={child}>
        <Subjects childId={child.id} />
      </ElemChild>
      <section aria-labelledby="sch-h" className="tj-card px-4 pt-[18px] pb-2 md:p-6">
        <div className="text-xs font-extrabold tracking-[0.12em] uppercase text-[#6e5e8a]">Сургууль</div>
        <h2 id="sch-h" className="m-0 text-xl md:text-[22px] font-bold">Хүсэлт, хоол, календарь</h2>
        <div className="mt-2 grid md:grid-cols-2 gap-x-6">
          {[["leave", "Чөлөө хүсэх", FiCalendar], ["daycare", "Өдөр өнжүүлэх", FiClock], ["feedback", "Санал хүсэлт", FiMessageSquare], ["meals", "Хоолны цэс · календарь", FiCoffee]].map(([tab, label, I]) => (
            <Link key={tab} to={`/school?c=${child.id}${tab === "meals" ? "" : `&tab=${tab}`}`} className="flex items-center gap-3 py-3 border-t border-[#efedf4] !text-[#1c1c1c]">
              <span className="h-9 w-9 rounded-xl bg-[#f3eeff] text-primary flex items-center justify-center shrink-0"><I size={18} /></span>
              <span className="flex-1 font-semibold">{label}</span>
              <FiChevronRight className="text-primary" />
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
